import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


// Get All Occupants
export const getOccupantsReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_OCCUPANTS_API, { params })
}

// Get Occupant Details by ID
export const getOccupantDetailsReq = (action) => {
    const { id, type, ...params } = action?.data || {};
    const url = apiEndpoints.GET_OCCUPANT_DETAILS_API.replace(':id', id);
    return axiosInstance.get(url, { params: { type, ...params } })
}

// Create Occupant
export const createOccupantReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;

    return axiosInstance.post(apiEndpoints.CREATE_OCCUPANT_API, body)
}

// Update Occupant
export const updateOccupantReq = (action) => {
    const payload = action?.data || {};
    const { id } = payload;
    const url = apiEndpoints.UPDATE_OCCUPANT_API.replace(':id', id);

    const body = { ...payload };
    delete body.id;
    delete body.onSuccess;

    return axiosInstance.put(url, body)
}

// Delete Occupant
export const deleteOccupantReq = (action) => {
    const { id, type } = action?.data || {};
    const url = apiEndpoints.DELETE_OCCUPANT_API.replace(':id', id);

    return axiosInstance.delete(url, { data: { type } })
}

// -----------------------------------------------------------------------------
// Occupant documents (multipart uploads)
// -----------------------------------------------------------------------------

export const uploadOccupantDocumentReq = (action) => {
    const { occupant_id, document_type, file } = action?.data || {};
    const url = apiEndpoints.UPLOAD_OCCUPANT_DOCUMENT_API.replace(':id', occupant_id);
    const form = new FormData();
    // The BE reads document_type from req.body BEFORE the file, so append it first
    form.append('document_type', document_type || 'OTHER');
    form.append('file', file);
    // Let the browser set the multipart boundary — don't override Content-Type.
    return axiosInstance.post(url, form);
};

export const deleteOccupantDocumentReq = (action) => {
    const { document_id } = action?.data || {};
    const url = apiEndpoints.DELETE_OCCUPANT_DOCUMENT_API.replace(':documentId', document_id);
    return axiosInstance.delete(url);
};

export const listOccupantDocumentsReq = (action) => {
    const { occupant_id } = action?.data || {};
    const url = apiEndpoints.LIST_OCCUPANT_DOCUMENTS_API.replace(':id', occupant_id);
    return axiosInstance.get(url);
};
